var _path, _path2, _path3, _path4, _linearGradient, _path5, _linearGradient2, _path6, _linearGradient3, _path7, _linearGradient4, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleBadgeEs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 40.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M-10-10h155v60H-10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130 40H5c-2.8 0-5-2.2-5-5V5c0-2.7 2.2-5 5-5h125c2.8 0 5 2.2 5 5v30c0 2.8-2.2 5-5 5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130 .8c2.3 0 4.2 1.9 4.2 4.2v30c0 2.3-1.9 4.2-4.2 4.2H5C2.7 39.2.8 37.3.8 35V5C.8 2.7 2.7.8 5 .8h125m0-.8H5C2.3 0 0 2.3 0 5v30c0 2.8 2.2 5 5 5h125c2.8 0 5-2.2 5-5V5c0-2.7-2.2-5-5-5z",
    fill: "#a6a6a6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2 21.8c-2.4 0-4.3 1.8-4.3 4.3 0 2.4 1.9 4.3 4.3 4.3s4.3-1.8 4.3-4.3c-.1-2.5-2-4.3-4.3-4.3zm0 6.8c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.4 1 2.4 2.6 0 1.5-1.2 2.6-2.4 2.6zm-9.4-6.8c-2.4 0-4.3 1.8-4.3 4.3 0 2.4 1.9 4.3 4.3 4.3s4.3-1.8 4.3-4.3-1.9-4.3-4.3-4.3zm0 6.8c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.4 1 2.4 2.6 0 1.5-1.1 2.6-2.4 2.6zm-11-5.5v1.8h4.3c-.1 1-.5 1.8-1 2.3-.6.6-1.6 1.3-3.3 1.3-2.7 0-4.7-2.1-4.7-4.8s2.1-4.8 4.7-4.8c1.4 0 2.5.6 3.3 1.3l1.3-1.3c-1.1-1-2.5-1.8-4.5-1.8-3.6 0-6.7 3-6.7 6.6 0 3.6 3.1 6.6 6.7 6.6 2 0 3.4-.6 4.6-1.9 1.2-1.2 1.6-2.9 1.6-4.2 0-.4 0-.8-.1-1.1h-6.2zm45.3 1.4c-.4-1-1.4-2.7-3.6-2.7s-4 1.7-4 4.3c0 2.4 1.8 4.3 4.2 4.3 1.9 0 3.1-1.2 3.5-1.9l-1.4-1c-.5.7-1.1 1.2-2.1 1.2s-1.6-.4-2.1-1.3l5.7-2.4-.2-.5zm-5.8 1.4c0-1.6 1.3-2.5 2.2-2.5.7 0 1.4.4 1.6.9l-3.8 1.6zM82.7 30h1.9V17.5h-1.9V30zm-3.1-7.3c-.5-.5-1.3-1-2.3-1-2.1 0-4.1 1.9-4.1 4.3s1.9 4.2 4.1 4.2c1 0 1.8-.5 2.2-1h.1v.6c0 1.6-.9 2.5-2.3 2.5-1.1 0-1.9-.8-2.1-1.5l-1.6.7c.5 1.1 1.7 2.5 3.8 2.5 2.2 0 4-1.3 4-4.4V22h-1.8v.7zm-2.2 5.9c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.3 1.1 2.3 2.6s-1 2.6-2.3 2.6zm24.4-11.1h-4.5V30h1.9v-4.7h2.6c2.1 0 4.1-1.5 4.1-3.9s-2-3.9-4.1-3.9zm.1 6h-2.7v-4.3h2.7c1.4 0 2.2 1.2 2.2 2.1 0 1.1-.8 2.2-2.2 2.2zm11.5-1.7c-1.4 0-2.8.6-3.3 1.9l1.7.7c.4-.7 1-.9 1.7-.9 1 0 1.9.6 2 1.6v.1c-.3-.2-1.1-.5-1.9-.5-1.8 0-3.6 1-3.6 2.8 0 1.7 1.5 2.8 3.1 2.8 1.3 0 1.9-.6 2.4-1.2h.1v1h1.8v-4.8c-.2-2.3-1.9-3.5-4-3.5zm-.2 6.8c-.6 0-1.5-.3-1.5-1.1 0-1 1.1-1.3 2-1.3.8 0 1.2.2 1.7.4-.1 1.2-1.1 2-2.2 2zm10.6-6.6l-2.1 5.4h-.1l-2.2-5.4h-2l3.3 7.6-1.9 4.2h1.9l5.1-11.8h-2zM107 30h1.9V17.5H107V30z",
    fill: "#fff"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 21.823,
    y1: 173.314,
    x2: 5.041,
    y2: 156.531,
    gradientTransform: "matrix(1 0 0 -1 0 182.047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.6c-.3.3-.5.7-.5 1.4v22.1c0 .6.2 1.1.5 1.4l.1.1L23 20.2v-.3L10.5 7.6z",
    fill: "url(#a)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 33.858,
    y1: 162.022,
    x2: 9.661,
    y2: 162.022,
    gradientTransform: "matrix(1 0 0 -1 0 182.047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1 24.3L23 20.2v-.3l4.1-4.1.1.1 4.9 2.8c1.4.8 1.4 2.1 0 2.9l-5 2.7z",
    fill: "url(#b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 24.85,
    y1: 159.727,
    x2: 2.092,
    y2: 136.969,
    gradientTransform: "matrix(1 0 0 -1 0 182.047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1 24.2L22.9 20 10.5 32.5c.5.5 1.2.5 2.1.1l14.5-8.4",
    fill: "url(#c)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 7.321,
    y1: 181.847,
    x2: 17.483,
    y2: 171.685,
    gradientTransform: "matrix(1 0 0 -1 0 182.047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1 15.8L12.5 7.5c-.9-.5-1.6-.4-2.1.1L22.9 20l4.2-4.2z",
    fill: "url(#d)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1 24.2l-14.5 8.2c-.8.5-1.5.4-2 0l-.1.1.1.1c.5.4 1.2.5 2 0l14.5-8.4z",
    opacity: 0.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 32.3c-.3-.3-.5-.7-.5-1.4v.1c0 .6.2 1.1.5 1.4v-.1zm21.5-11l-5 2.8.1.1 4.9-2.8c.7-.4 1-.9 1-1.4 0 .5-.3 1-1 1.3z",
    opacity: 0.12
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.6L32 18.7c.6.4 1 .8 1 1.3 0-.5-.3-1-1-1.4L12.5 7.5C11.1 6.7 10 7.4 10 9v.1c0-1.6 1.1-2.2 2.5-1.5z",
    opacity: 0.25,
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3 13V7h1.8c.9 0 1.7.3 2.2.8.6.6.8 1.3.8 2.2 0 .9-.3 1.6-.8 2.2-.6.6-1.3.8-2.2.8h-1.8zm.8-.7h1.1c.7 0 1.2-.2 1.6-.6.4-.4.6-1 .6-1.7s-.2-1.3-.6-1.7c-.4-.4-1-.6-1.6-.6h-1.1v4.6zm5.2.7V7h.7v6h-.7zm3.8.2c-.4 0-.9-.1-1.3-.4-.4-.3-.7-.7-.8-1.2l.7-.3c.1.3.3.6.5.8.3.2.6.3.9.3.3 0 .6-.1.9-.3.2-.2.4-.4.4-.7 0-.3-.1-.6-.4-.8-.2-.2-.6-.4-1.1-.5-.5-.2-.9-.4-1.2-.6-.3-.3-.4-.6-.4-1s.2-.8.5-1.1c.3-.3.8-.5 1.3-.5s.9.1 1.2.4c.3.3.5.5.6.8l-.7.3c0-.2-.2-.4-.4-.5-.2-.2-.5-.2-.8-.2-.3 0-.5.1-.8.2-.1.1-.2.3-.2.6 0 .2.1.4.3.6.2.2.5.3.9.4.3.1.5.2.7.3.2.1.4.2.6.4.2.1.4.3.5.6.1.2.2.5.2.8 0 .3-.1.6-.2.8-.1.2-.3.4-.5.5l-.6.3c-.3-.1-.6 0-.8 0zM55 13h-.8V7h2c.5 0 .9.2 1.3.5s.6.8.6 1.3-.2.9-.6 1.3c-.4.3-.8.5-1.3.5H55V13zm0-3.1h1.3c.3 0 .6-.1.8-.3.2-.2.3-.5.3-.7 0-.3-.1-.5-.3-.7-.2-.2-.5-.3-.8-.3H55v2zm9 2.3c-.6.6-1.3.9-2.2.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2 0-.9.3-1.6.9-2.2.6-.6 1.3-.9 2.2-.9.9 0 1.6.3 2.2.9.6.6.9 1.3.9 2.2 0 .9-.3 1.6-.9 2.2zm-3.8-.5c.4.4 1 .7 1.6.7.6 0 1.2-.2 1.6-.7.4-.4.7-1 .7-1.7s-.2-1.3-.7-1.7c-.4-.4-1-.7-1.6-.7-.6 0-1.2.2-1.6.7-.4.4-.7 1-.7 1.7s.2 1.3.7 1.7zM66 13V7h.9l2.9 4.7V7h.8v6h-.8l-3.1-4.9V13H66zm6 0V7h.8v6H72zm2.1 0V7h2.2c.5 0 .9.2 1.2.5.4.3.5.7.5 1.2 0 .3-.1.5-.2.8-.1.2-.3.4-.6.5.3.1.5.3.7.5.2.2.3.5.3.9 0 .5-.2.9-.5 1.2-.4.3-.8.5-1.3.5h-2.3zm.8-3.4h1.4c.3 0 .5-.1.7-.3.2-.2.3-.4.3-.6s-.1-.5-.3-.7c-.2-.2-.4-.3-.7-.3h-1.4v1.9zm0 2.7h1.6c.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7 0-.2-.1-.5-.3-.7-.2-.2-.4-.3-.7-.3H75v2zm4.4.7V7h.7v5.3h2.6v.7h-3.3zm7.8-5.2h-2.7v1.9h2.5v.7h-2.5v1.9h2.7v.7h-3.5V7h3.5v.8zm6.7 0h-2.7v1.9h2.5v.7h-2.5v1.9h2.7v.7h-3.5V7h3.5v.8zM95 13V7h1l2.9 4.7V7h.8v6h-.8l-3.1-4.9V13H95z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleBadgeEs);
export default __webpack_public_path__ + "static/media/google-badge-es.a0be6a43f02922e751ccd6304ebf1ed0.svg";
export { ForwardRef as ReactComponent };